<template>
  <div>
    <h1>Antal tabletter.</h1>
    <p>Vi förskriver Sildenafil (Viagra) 50 mg,<br>ange nedan hur många tabletter du önskar:</p>

    <select class="select-pills" id="pills" v-model="product">
      <option value="SIL-4">4 st</option>
      <option value="SIL-12">12 st</option>
      <option value="SIL-24">24 st</option>
    </select>

  </div>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
    name: "CheckoutPills",
    data() {
        return {
            product: "SIL-4",
        }
    },
    mounted() {
      this.$store.commit( 'persist/setProduct', { product: this.product } );
    },
    computed: {
      ...mapGetters("persist", [
        "getProduct"
      ]),
      chosenProduct() {
        return this.getProduct
      }
    },
    watch: { 
      product(newVal) {
        this.$store.commit( 'persist/setProduct', { product: newVal } );
      }
    }
}
</script>